module.exports = __webpack_public_path__ + "static/media/orbitron-black.cc55bc64.ttf";